// extracted by mini-css-extract-plugin
module.exports = {"container":"PageContent_container__JYVmk","title":"PageContent_title__2ZILE","children":"PageContent_children__3JfMN"};